import { FC } from "react";
import { TrendingStocksFieldLabels } from "../types";

interface StockDetailsAccordionProps {
  isExpanded: boolean;
  buyPrice?: string;
  targetPrice?: string;
  stopLoss?: string;
  potentialReturns?: string;
  moneySymbol?: string;
  labels?: TrendingStocksFieldLabels;
}

const TredingStockCardAccordion: FC<StockDetailsAccordionProps> = ({
  isExpanded,
  buyPrice,
  targetPrice,
  stopLoss,
  potentialReturns,
  labels,
  moneySymbol,
}) => (
  <div
    className={`grid transition-[grid-template-rows,opacity] duration-300 ease-in-out ${
      isExpanded ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
    }`}
  >
    <div className="overflow-hidden">
        <div className="mt-4 border-t border-[#E5E5E5] pt-3 font-normal">
          <div className="mb-3 flex items-center justify-between text-[12px] md:text-sm">
            <div className="flex flex-col gap-1">
              <div className="text-[#666666]">
                {labels?.buyPrice ?? "Buy"}
              </div>
              <div className="font-normal text-[#1A1A1A]">
                {moneySymbol}
                {buyPrice ?? "--"}
              </div>
            </div>
            <div className="text-right flex flex-col gap-1">
              <div className="text-[#666666]">
                {labels?.targetPrice ?? "Target Price"}
              </div>
              <div className="font-normal text-[#1A1A1A]">
                {moneySymbol}
                {targetPrice ?? "--"}
              </div>
            </div>
          </div>

          <div className="mb-0 md:mb-2 flex items-center justify-between border-t border-[#E5E5E5] pt-3 text-[12px] md:text-sm">
            <div className="flex flex-col gap-1">
              <div className="text-[#666666]">
                {labels?.stopLoss ?? "Stop Loss"}
              </div>
              <div className="font-normal text-[#1A1A1A]">
                {moneySymbol}
                {stopLoss ?? "--"}
              </div>
            </div>
            <div className="text-right flex flex-col gap-1">
              <div className="text-[#666666]">
                {labels?.potentialReturns ?? "Potential returns"}
              </div>
              <div className="font-normal text-[#089E86]">
                {potentialReturns ?? "--"}
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
);

export default TredingStockCardAccordion;
